<template>
  <div class="container">
    <div class="embed-responsive embed-responsive-16by9 mt-5">
      <iframe v-if="isYoutube()" class="embed-responsive-item" :src="url" allowfullscreen></iframe>
      <iframe v-if="isVimeo()" class="embed-responsive-item" :src="url" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    host: String,
    videoId: String,
    h: String,
  },
  data() {
    return {};
  },
  methods: {
    isYoutube() {
      if (this.host === "y") {
        return true;
      }
      return false;
    },
    isVimeo() {
      if (this.host === "v") {
        return true;
      }
      return false;
    },
  },
  computed: {
    url() {
      if (this.host === "y") {
        return `https://www.youtube.com/embed/${this.videoId}?rel=0`;
      } else if (this.host === "v") {
        return `https://player.vimeo.com/video/${this.videoId}?h=${this.h}`;
      } else {
        return "";
      }
    },
  },
};
</script>
